import { StockDetailsInterface } from '../modals/stock-details-modal/stock-details-modal.component';
import { Crate } from '../../models/Crate';

type PromiseValue<T> = T extends Promise<infer U> ? U : T;

export type CrateDetailsResponse = PromiseValue<ReturnType<import('../core/data-sources/crates-data-source.service').CratesDataSourceService['getCrateById']>>;
export type CrateDetailsWithInvoice = NonNullable<CrateDetailsResponse> & { invoice: unknown };

export function withCrateInvoice(itemDetails: CrateDetailsResponse): CrateDetailsWithInvoice | null {
  if (!itemDetails) {
    return null;
  }

  return {
    ...itemDetails,
    invoice: (itemDetails.crate as Crate & { invoices?: unknown[] }).invoices?.[0] || null
  };
}

export function buildStockDetailsFromCrate(
  crate: Crate,
  itemDetails: StockDetailsInterface['itemDetails'],
  options: { isExit?: boolean; page?: number } = {}
): StockDetailsInterface {
  const skuGroups = crate.skuGroups.map(skuGroup => ({
    crateId: skuGroup.crateId || crate.id,
    createdAt: skuGroup.createdAt || crate.createdAt,
    name: skuGroup.name,
    packSize: skuGroup.packSize,
    quantity: skuGroup.quantity,
    sku: skuGroup.sku,
    updatedAt: skuGroup.updatedAt || crate.updatedAt
  }));

  return {
    item: {
      commentsQty: crate.commentsQty,
      createdAt: crate.createdAt,
      id: crate.id,
      position: crate.position,
      section: crate.section,
      palletStatus: crate.palletStatus || crate.state,
      skuGroups,
      state: crate.state,
      tagRfid: crate.tagRfid || '',
      tenantId: crate.tenantId,
      type: crate.type,
      updatedAt: crate.updatedAt,
      x: crate.x,
      y: crate.y,
      z: crate.z
    },
    itemDetails,
    isExit: options.isExit || false,
    page: options.page || 0
  };
}
